export default __webpack_public_path__ + "static/media/google.5a66313e.svg";